function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
import useDirection from '../direction/use_direction';
var useStyles = _ref => {
  var {
    arrow,
    open,
    userSelect,
    placement
  } = _ref;
  var theme = useTheme();
  var {
    isRTL
  } = useDirection();
  var isHc = theme.mode === 'contrast';
  return React.useMemo(() => {
    return _objectSpread({
      [isRTL ? 'right' : 'left']: 0,
      pointerEvents: userSelect === 'none' ? 'none' : undefined,
      position: 'absolute',
      top: 0,
      userSelect,
      '> .vn-tooltip': _objectSpread({
        backgroundColor: theme.palette.background.container,
        borderColor: theme.palette.background.container,
        borderRadius: theme.borderRadius2,
        borderStyle: 'solid',
        borderWidth: 1,
        boxSizing: 'border-box',
        color: theme.palette.foreground.default,
        minHeight: theme.layout.size6,
        maxWidth: 300,
        opacity: open ? 1 : 0,
        padding: "".concat(theme.layout.size1, " calc(").concat(theme.layout.size2, " - 1px)"),
        position: arrow ? 'relative' : undefined,
        wordWrap: 'break-word',
        '> .vn-tooltip__arrow': _objectSpread(_objectSpread({
          position: 'absolute'
        }, isHc && {
          '&::before': {
            content: "' '",
            display: 'block',
            position: 'absolute',
            width: 0,
            height: 0,
            borderWidth: "0 ".concat(theme.layout.size2, " ").concat(theme.layout.size2, " ").concat(theme.layout.size2),
            borderStyle: 'solid',
            borderColor: 'transparent',
            borderBottomColor: theme.palette.foreground.default
          }
        }), {}, {
          '&::after': _objectSpread({
            content: "''",
            display: 'block',
            position: 'absolute',
            width: 0,
            height: 0,
            borderWidth: "0 ".concat(theme.layout.size2, " ").concat(theme.layout.size2, " ").concat(theme.layout.size2),
            borderStyle: 'solid',
            borderColor: 'transparent',
            borderBottomColor: theme.palette.background.container
          }, isHc && {
            top: '1px'
          })
        }),
        '&[data-placement="bottom"], &[data-placement="top"]': {
          margin: arrow ? "".concat(theme.layout.size3, " 0") : "".concat(theme.layout.size2, " 0")
        },
        '&[data-placement="left"], &[data-placement="right"]': {
          margin: arrow ? "0 ".concat(theme.layout.size3) : "0 ".concat(theme.layout.size2)
        },
        '&[data-placement="bottom"] .vn-tooltip__arrow': _objectSpread(_objectSpread({
          top: "-".concat(theme.layout.size2),
          marginLeft: "-".concat(theme.layout.size2)
        }, placement === 'bottom-end' && {
          marginLeft: "-".concat(theme.layout.size3)
        }), placement === 'bottom-start' && {
          marginLeft: "-".concat(theme.layout.size1)
        }),
        '&[data-placement="left"] .vn-tooltip__arrow': _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          right: 0,
          marginTop: "-".concat(theme.layout.size2)
        }, placement === 'left-end' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'leading-end' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'left-start' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'leading-start' && {
          marginTop: "-".concat(theme.layout.size2)
        }), isHc && {
          '&::before': {
            borderColor: 'transparent',
            borderLeftColor: theme.palette.foreground.default,
            borderWidth: "".concat(theme.layout.size2, " 0 ").concat(theme.layout.size2, " ").concat(theme.layout.size2)
          }
        }), {}, {
          '&::after': _objectSpread({
            borderColor: 'transparent',
            borderWidth: "".concat(theme.layout.size2, " 0 ").concat(theme.layout.size2, " ").concat(theme.layout.size2),
            borderLeftColor: theme.palette.background.container
          }, isHc && {
            top: 0,
            left: '-1px'
          })
        }),
        '&[data-placement="top"] .vn-tooltip__arrow': _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          bottom: 0,
          marginLeft: "-".concat(theme.layout.size2)
        }, placement === 'top-end' && {
          marginLeft: "-".concat(theme.layout.size3)
        }), placement === 'top-start' && {
          marginLeft: "-".concat(theme.layout.size1)
        }), isHc && {
          '&::before': {
            borderColor: 'transparent',
            borderTopColor: theme.palette.foreground.default,
            borderWidth: "".concat(theme.layout.size2, " ").concat(theme.layout.size2, " 0 ").concat(theme.layout.size2)
          }
        }), {}, {
          '&::after': _objectSpread({
            borderColor: 'transparent',
            borderWidth: "".concat(theme.layout.size2, " ").concat(theme.layout.size2, " 0 ").concat(theme.layout.size2),
            borderTopColor: theme.palette.background.container
          }, isHc && {
            top: '-1px'
          })
        }),
        '&[data-placement="right"] .vn-tooltip__arrow': _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          left: 0,
          marginTop: "-".concat(theme.layout.size2),
          marginLeft: "-".concat(theme.layout.size2)
        }, placement === 'right-end' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'trailing-end' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'right-start' && {
          marginTop: "-".concat(theme.layout.size2)
        }), placement === 'trailing-start' && {
          marginTop: "-".concat(theme.layout.size2)
        }), isHc && {
          '&::before': {
            borderColor: 'transparent',
            borderRightColor: theme.palette.foreground.default,
            borderWidth: "".concat(theme.layout.size2, " ").concat(theme.layout.size2, " ").concat(theme.layout.size2, " 0")
          }
        }), {}, {
          '&::after': _objectSpread({
            borderColor: 'transparent',
            borderWidth: "".concat(theme.layout.size2, " ").concat(theme.layout.size2, " ").concat(theme.layout.size2, " 0"),
            borderRightColor: theme.palette.background.container
          }, isHc && {
            right: '-1px',
            top: 0
          })
        })
      }, isHc && {
        borderColor: theme.palette.foreground.default
      })
    }, highContrastMediaQuery(theme));
  }, [arrow, isHc, isRTL, open, placement, theme, userSelect]);
};
export default useStyles;